import React, { useState, useEffect } from "react";
import AssetRequestList from "./AssetRequestList";
import AccessRequestList from "./AccessRequestList";
import PageTitle from "../../components/PageTitle";
import { Link } from "react-router-dom";
import { toggleMenu } from "../../utils/helpers";
import { useSearchParams } from "react-router-dom";

const ITAssetAndAccessRequestsTabs = ({ title, description }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [totalRequest, setTotalRequest] = useState(0);
  const handleTotalRequestChange = (count) => {
    setTotalRequest(count);
  };
  const tabs = [
    { label: "Asset Requests", component: AssetRequestList },
    { label: "Access Requests", component: AccessRequestList },
  ];

  useEffect(() => {
    const tabParam = searchParams.get("tab");
    if (tabParam === "access") {
      setActiveTabIndex(1); // Switch to Access Requests tab
    } else if (tabParam === "asset") {
      setActiveTabIndex(0); // Switch to Asset Requests tab
    }
  }, [searchParams]);

  const handleTabChange = (index) => {
    setActiveTabIndex(index);
    const tabName = index === 0 ? "asset" : "access";
    setSearchParams({ tab: tabName });
  };

  return (
    <div className="wrapper-body">
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
        <div className="page-heading mb-0 d-flex justify-content-between align-items-center asset--and--access-container">
          <div className="filters flex-grow-1 me-3 mb-0"></div>
          <div className="total m-0 flex-shrink-0">
            Total {tabs[activeTabIndex].label}: <span>{totalRequest ?? 0}</span>
          </div>
        </div>
      </div>

      <div className="card ">
        <div className="d-flex justify-content-between align-items-center">
          <ul className="nav nav-tabs" role="tablist">
            {tabs.map((item, index) => (
              <li className="nav-item" role="presentation" key={index}>
                <button
                  className={`nav-link ${
                    activeTabIndex === index ? "active" : ""
                  }`}
                  type="button"
                  role="tab"
                  aria-selected={activeTabIndex === index}
                  onClick={() => handleTabChange(index)}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
          <div className="actions">
            <Link
              to={`/dashboard/createAssetRequest?tab=${
                activeTabIndex === 0 ? "asset" : "access"
              }`}
              className="export theme-button"
            >
              Create Request
            </Link>
          </div>
        </div>

        <div className="tab-content px-3">
          {tabs.map((item, index) => {
            const Component = item.component;
            return (
              activeTabIndex === index && (
                <div
                  key={index}
                  className="tab-pane fade show active"
                  role="tabpanel"
                >
                  <Component
                    title={item.label}
                    description=""
                    onTotalRequestChange={handleTotalRequestChange}
                  />
                </div>
              )
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ITAssetAndAccessRequestsTabs;
